export default "__VITE_ASSET__jZ8PgnO0__"